import { ProductImageUpload, ProductImage } from './ProductImageUpload';

interface AdminProductImagesSectionProps {
  producerId: string;
  productId: string | null;
  images: ProductImage[];
  onImagesChange: (images: ProductImage[]) => void;
  disabled?: boolean;
  /** Callback to ensure draft exists before uploading (for create mode) */
  ensureDraftExists?: () => Promise<string | null>;
  /** Is draft creation in progress */
  isCreatingDraft?: boolean;
}

/**
 * Reusable product images section for Create and Edit views.
 * Now supports direct image uploads in create mode via auto-draft creation.
 */
export function AdminProductImagesSection({
  producerId,
  productId,
  images,
  onImagesChange,
  disabled = false,
  ensureDraftExists,
  isCreatingDraft = false,
}: AdminProductImagesSectionProps) {
  return (
    <ProductImageUpload
      producerId={producerId}
      productId={productId}
      images={images}
      onChange={onImagesChange}
      disabled={disabled}
      ensureDraftExists={ensureDraftExists}
      isCreatingDraft={isCreatingDraft}
    />
  );
}
